module.exports = __webpack_public_path__ + "img/FR.c8f89604.jpg";